export var source_footer_main_link = { "uid": "source_footer_main_link", "fields": { "title": { "defaultValue": "" }, "link_title": { "defaultValue": "" }, "url": { "defaultValue": "" } } };
